import React, { useContext, useState } from 'react'
import Modal from '../../../../components/Modal'
import { AuthContext } from '../../../../context/AuthContext'
import { useHttp } from '../../../../hooks/http.hook'
import validator from '../../../../hooks/validator.hook'
import { observer } from 'mobx-react'
import ModalForm from '../../../../components/Modals/ModalForm/ModalForm'
import PatientPageStore from '../Store/PatientPageStore'
import FormInput from '../../../../components/Inputs/FormInput/FormInput'
import FormAttention from '../../../../components/FormAttention'
import AttentionGenerator from '../../../../components/Form/AttentionGenerator'
import {io} from "socket.io-client";



const ResetPasswordModal = observer(() => {
  const { token, logout, userId } = useContext(AuthContext)
  const { request } = useHttp()
  const { validatePassword } = validator()
  const [status, setStatus] = useState(0)

  const [formData, setFormData] = useState({
    password: '',
    newPassword: ''
  })

  // const validPassword = validatePassword(formData.password)

  const baseURL = process.env.REACT_APP_BASE_URL
  const resetPasswordRequest = async (newPassword) => {
    const url = `${baseURL}/api/v2/patients/${userId}/passwordreset`
    const { data, status } = await request(url, 'PUT', newPassword, { Authorization: `Bearer ${token.token}` })
    setStatus(status)
    if (status === 200) {
      logout()
	  location.href='/';
    }
  }
  const submitHandler = e => {
    e.preventDefault()
    resetPasswordRequest(formData)
  }
  const inputHandler = event => {
    setFormData({ ...formData, [event.target.name]: event.target.value })
  }
  return (
    <Modal>
      <ModalForm
        ready={status === 200}
        readyText={'Доступ отозван!'}
        readyBtnText={'Продолжить'}
        onSubmit={submitHandler}
        onSubmitTitle={'Удалить доступ'}
        title={'Удалить доступ'}
        closeHandler={() => PatientPageStore.closeResetPasswordModal()}
      >
		Вы уверены, что хотите запретить доступ к этому кабинету со снимками?
      </ModalForm>
    </Modal>
  )
})

export default ResetPasswordModal 

